// import { EmployeeList } from "components/Employee";

import { AuthenticatedLayout } from "../../layouts";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { EmployeeList } from "../../components/EmployeeList";
import { FC } from "react";
import { PayrollVocationalEarningList } from "../../components/PayrollVocationalEarningList/PayrollVocationalEarningList";

export interface IPayrollVocationalEarningsListPage {}

export const PayrollVocationalEarningsListPage: FC<IPayrollVocationalEarningsListPage> = (
  props: IPayrollVocationalEarningsListPage
) => {
  return (
    <AuthenticatedLayout
      pageTitle="Payroll Vocational Earning"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: "", navigateTo: "/payroll-federal-earning/list" },
      ]}
      mainContents={<PayrollVocationalEarningList />}
    />
  );
};
